import React from "react"
import { Tabs, Tab, makeStyles } from "@material-ui/core"
import { Card_Icon, Apple_Card_Icon, GPay_Card_Icon } from "./Icons"
const useStyles = makeStyles(() => ({
  root: {
    background: "#fff",
    borderRadius: 40,
    // width: "fit-content",
    width: "100%",
    margin: "auto",
    marginTop: 10,
    marginBottom: 20,
    boxSizing: "border-box",
    maxWidth: 340,
    "& .MuiTabs-scroller.MuiTabs-fixed": {
      border: "2px solid var(--receipt-tab-blue-color)",
      borderRadius: "30px",
    },
  },
  indicator: {
    height: "100%",
    borderRadius: 40,
    backgroundColor: "var(--receipt-tab-blue-color)",
    transition: "all .3s ease",
    WebkitTransform: "all .3s ease",
    transform: "scale(1.1)",
    WebkitTransform: "scale(1.1)",
  },
  tab: {
    textTransform: "none",
    fontWeight: 600,
    zIndex: 1,
    width: "50%",
  },
  selected: {
    color: "#fff !important",
  },
}))

export default function Tab_Animation(props) {
  const { defaultTabView = 0, onUpdate = () => "" } = props || {}
  const classes = useStyles()
  const [value, setValue] = React.useState(defaultTabView)

  const tabList = [
    {
      label: "Physical Card",
      tabUI: (
        <div style={{ display: "flex" }}>
          <Card_Icon />
          <div style={{ marginLeft: 5 }}>{`CARD`}</div>
        </div>
      ),
    },
    {
      label: "Virtual Card",
      tabUI: (
        <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
          <Apple_Card_Icon />
          <GPay_Card_Icon />
        </div>
      ),
    },
  ]

  React.useEffect(() => {
    setValue(defaultTabView)
  }, [defaultTabView])

  return (
    <>
      <Tabs
        value={value}
        onChange={(e, index) => {
          setValue(index)
          onUpdate({
            index: index,
            value: tabList[index],
          })
        }}
        className={classes.root}
        TabIndicatorProps={{ className: classes.indicator }}
        centered
      >
        {tabList.map((cardItm) => {
          return (
            <Tab
              label={<div>{cardItm?.tabUI}</div>}
              classes={{ root: classes.tab, selected: classes.selected }}
            />
          )
        })}
      </Tabs>
    </>
  )
}
